import { Component, ChangeDetectionStrategy} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FormControl } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-custom-dob',
  templateUrl: './custom-dob.component.html',
  styleUrls: ['./custom-dob.component.scss']
})
export class CustomDobComponent implements ICellRendererAngularComp {

  params: any;
  dobControl = new FormControl();

  constructor() { }

  agInit(params): void {
    this.params = params;
    this.dobControl.setValue(params.dobValue);
  }


  validateDOB(event) {
    const inp = String.fromCodePoint(event.keyCode);
    if (!(/^[0-9/]+$/).test(inp)) {
      event.preventDefault();
      return false;
    }
    let DobVal = this.dobControl.value;
    if ((!DobVal && event.key === '/') ||
      (DobVal && (DobVal.length === 3 || DobVal.length >= 6) && event.key === '/')) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  updateDOB(event) {
    let DobVal = this.dobControl.value;
    if (!DobVal || typeof DobVal !== 'string') {
      if (!DobVal || DobVal.length === 0) {
        this.UpdateAge(this.dobControl.value);
      }
      return;
    }
    if (event.inputType === "insertText") {
      this.handleInsertText(DobVal, event.data);
    } else if (DobVal.length > 0) {
      const trimmedVal = this.rtrim(DobVal, '/');
      this.dobControl.setValue(trimmedVal);
      if (!trimmedVal || trimmedVal.length === 0) {
        this.UpdateAge(this.dobControl.value);
      }
    }
  }

  private handleInsertText(DobVal: string, data: string): string {
    if (DobVal.length === 2 && data === '/') {
      DobVal = '0' + DobVal;
      this.dobControl.setValue(DobVal);
    } else if (DobVal.length === 5 && data === '/') {
      let splitDate = DobVal.replace(/\/+$/, '').split('/');
      DobVal = splitDate[0] + '/0' + splitDate[1] + '/';
      this.dobControl.setValue(DobVal);
    } else if (DobVal.length === 2 || DobVal.length === 5) {
      DobVal = DobVal + '/';
      this.dobControl.setValue(DobVal);
    }
    if (DobVal.length === 10) {
      this.UpdateAge(this.dobControl.value);
    }
    return DobVal;
  }

  clearText() {
    this.dobControl.setValue(null);
    this.params.data[this.params.column.colId] = '';
    this.params.context.componentParent.customRefresh(this.params.column.colId);
  }

  UpdateAge(value) {
    this.params.data[this.params.column.colId] = value
    this.params.context.componentParent.customRefresh(this.params.column.colId);
  }

  rtrim(str, ch) {
    let i = str.length;
    while (i-- && str.charAt(i) === ch);
    return str.substring(0, i + 1);
  }

  refresh(): boolean {
    return true;
  }

}
